import {
    FETCH_UPDATE_ACTOR_TYPE_REQUEST,
    FETCH_UPDATE_ACTOR_TYPE_SUCCESS,
    FETCH_UPDATE_ACTOR_TYPE_FAILURE,
    SET_UPDATE_ACTOR_TYPE
} from '../../actions/actorTypes/update-actorTypes-actions';

const initialState = {
    updatedActorType: null,
    group: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const UpdateActorTypeReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_UPDATE_ACTOR_TYPE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case SET_UPDATE_ACTOR_TYPE:
            return {
                ...state,
                isLoading: false,
                error: null,
                actorType: { ...action.payload }
            };
        case FETCH_UPDATE_ACTOR_TYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updatedActorType: action.payload[0],
            };
        case FETCH_UPDATE_ACTOR_TYPE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default UpdateActorTypeReducer;